import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tab } from 'component/base'
import { Custom } from 'component/pieces'

export const Unsoten = props => {
  const { multiple, setSelectedId, selectedId } = props

  const [loading, setLoading] = useState(false)

  return (
    <Tab
      panes={[
        {
          menuItem: '運送店',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.Kumiaiin
                mode='unsoten'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: '単組他',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.TansoSeikyuShiharaisaki
                mode='torihikisaki'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
                loading={loading}
                setLoading={setLoading}
              />
            </Tab.Pane>
          ),
        },
      ]}
    />
  )
}

Unsoten.propTypes = {
  multiple: PropTypes.bool,
  setSelectedId: PropTypes.func,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Unsoten.defaultProps = {
  multiple: false,
  setSelectedId: () => {},
  selectedId: undefined,
}
